document.addEventListener('DOMContentLoaded', () => {
  const grid = document.querySelector('#product-grid');
  const loader = document.getElementById('infinite-scroll-loader');
  const paginationWrapper = document.getElementById('pagination-wrapper');
  let nextPageUrl = document.querySelector('.pagination__item--prev')?.href;
  let loading = false;

  if (!grid || !nextPageUrl) return;

  const loadMoreProducts = async () => {
    if (loading || !nextPageUrl) return;
    loading = true;
    loader.style.display = 'block';

    try {
      const response = await fetch(nextPageUrl);
      const text = await response.text();
      const html = new DOMParser().parseFromString(text, 'text/html');

      const newItems = html.querySelectorAll('#product-grid .grid__item');
      const newPagination = html.querySelector('#pagination-wrapper');

      newItems.forEach(item => grid.appendChild(item));

      if (newPagination) {
        const newNextPage = newPagination.querySelector('.pagination__item--prev')?.href;
        if (newNextPage) {
          nextPageUrl = newNextPage;
        } else {
          nextPageUrl = null;
          paginationWrapper.style.display = 'none'; // hide pagination
        }
      } else {
        nextPageUrl = null;
        paginationWrapper.style.display = 'none'; // hide pagination
      }

    } catch (err) {
      console.error('Infinite scroll failed:', err);
    } finally {
      loading = false;
      loader.style.display = 'none';
    }
  };

  const onScroll = () => {
    if (!nextPageUrl || loading) return;

    const scrollPos = window.innerHeight + window.scrollY;
    const triggerPos = document.body.offsetHeight - 300;

    if (scrollPos >= triggerPos) {
      loadMoreProducts();
    }
  };

  window.addEventListener('scroll', onScroll);

  // Optional: hide pagination immediately on page load
  paginationWrapper.style.display = 'none';
});
